import { defineComponent as _defineComponent } from 'vue'
import { CourseForm } from '@/entities/trainings';
  import { Button } from '@/ui/components/Button';
  import { useModal } from '@/ui/concerns/modals/useModal';
  import { router } from '@/ui/routes';
  import { ref } from 'vue';
  import CreateCourseModal from './CreateCourseModal.vue';
  import { courseService } from '@/services/courseService';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CreateCourseButton',
  props: {
    withPlusIcon: { type: Boolean, default: true },
  },
  setup(__props) {

  

  const [isModalOpen, openModal, closeModal] = useModal();

  const isCreating = ref(false);

  const submitCourse = async (courseForm: CourseForm) => {
    let newCourse;

    try {
      isCreating.value = true;
      newCourse = await courseService.create(courseForm);

      closeModal();
    } catch (error) {
      console.error('Failed to create course:', error);
    } finally {
      isCreating.value = false;
    }

    return newCourse;
  };

  const handleSuccess = async (courseForm: CourseForm) => {
    const course = await submitCourse(courseForm);

    if (course) {
      router.push({ name: 'courseBuilder', params: { id: course.id.toString() } });
    }
  };

return { __sfc: true,isModalOpen, openModal, closeModal, isCreating, submitCourse, handleSuccess, Button, CreateCourseModal }
}

})